import { GET_CLASSROOMS_SUCCESS } from '../class-roll/actions';
import { GET_PRODUCT_TEACHERS_SUCCESS } from '../teacher-roll/actions';
import messages from './messages';

const initState = {
    teachers: [],
    classrooms: [],
    isTeachersLoaded: false,
    isClassroomsLoaded: false
};

const dataFilterOption = {
    classrooms: [{ key: -1, value: messages.defaultOptionClassrooms, selected: true }],
    teachers: [{ key: -1, value: messages.defaultOptionTeachers, selected: true }]
};

const getUpdatedClassrooms = (classrooms) => {
    const classes = classrooms.map(classroom => ({
        value: classroom.name,
        key: classroom.classroomId,
        selected: false,
        studentsCount: classroom.studentsProfileId.length,
        teachersId: classroom.teachers.map(teacher => teacher.userProfileId)
    }));

    return dataFilterOption.classrooms.concat(classes);
};

const getUpdatedTeachers = (teachers) => {
    const teachersList = teachers.map(teacher => ({
        value: `${teacher.lastName}, ${teacher.firstName}`,
        name: `${teacher.firstName} ${teacher.lastName}`,
        key: teacher.userProfileId,
        selected: false
    }));

    return dataFilterOption.teachers.concat(teachersList);
};

export default function (state = initState, action) {
    switch (action.type) {
    case GET_PRODUCT_TEACHERS_SUCCESS: {
        return {
            ...state,
            teachers: getUpdatedTeachers(action.data),
            isTeachersLoaded: true
        };
    }

    case GET_CLASSROOMS_SUCCESS:
    {
        return {
            ...state,
            classrooms: getUpdatedClassrooms(action.data),
            isClassroomsLoaded: true
        };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/sign-in-cards/reducer.js